import React from 'react' // eslint-disable-line no-unused-vars
import '../../ui-elements/Modals'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import '../../css/ui-elements/modals.css'
import CountryAwareComponent from '../CountryAwareComponent'
import { connect } from 'react-redux'
import StaticConfig from '../StaticConfig'

class PrescribingInformation extends CountryAwareComponent {
  constructor (props) {
    super(props)
    this.componentName = 'PrescribingInformation'
  }

  render () {
    const languageContent = this.props.pageContent.content
    const prescribingLinks = StaticConfig.Context.ComponentConfig.prescribingInfoUrls || []
    const displayText = prescribingLinks.length > 0 ? languageContent.presInfoAccess : languageContent.presInfoAccessNoLink
    const jsx = (
      <div>
        <Modal
          isOpen
          toggle={this.props.toggle}
          wrapClassName='modal-primary'
          size='lg'
        >
          <ModalHeader toggle={this.props.toggle}>{languageContent.page.HOME.medicalInquiryMenu.presInfo}</ModalHeader>
          <ModalBody>
            <p className='text-center'>{displayText}</p>
            {
              prescribingLinks.map((link, index) => 
                <div id={`prescribingLink-${index}`} className='mt-2 modal-link'>
                  <a
                    id={`prescribingInput-${index}`}
                    data-tag='track-exit' data-analytics-text='Prescribing Information'
                    className='btn btn-primary btn-block btn-rounded'
                    style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}
                    href={link.url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {`${languageContent.continueTo} ${link.url}`}
                  </a>
                </div>
              )
            }
          </ModalBody>
        </Modal>
      </div>)
    return this.countriesMatched() ? jsx : null
  }
}

function mapStateToProps ({ pageContent }) { return { pageContent } }

export default connect(mapStateToProps)(PrescribingInformation)



// WEBPACK FOOTER //
// ./src/mi-app/modals/PrescribingInformation.js